angular.module('agreements')
    .controller('AgreementCategoryListController', function ($scope, data, $uibModalInstance, AgreementCategory, AgreementCategoryService, AgreementCategoryConst) {
        this.AgreementCategoryService = AgreementCategoryService
        this.$onInit = () => {
            this.reload()
        }

        $scope.$on(AgreementCategoryConst.eventUpdate, () => this.reload())

        this.close = () => $uibModalInstance.close()
        this.reload = () => {
            AgreementCategory.list().$promise.then(response => this.items = response)
        }
    })
